import { safeInitializeAuthorizer } from '@/auth/useAuthorizer'
import { useAuthStore } from '@/auth/useAuthStore'

import { getRedirectToLogin } from './common/getRedirectToLogin'
import { type HermesGuardFn } from './types'

export const checkAuthenticated: HermesGuardFn = async (to, from) => {
  const { meta = {} } = to

  const authStore = useAuthStore()

  if (!from?.name && authStore.user && authStore.brandSession) {
    await safeInitializeAuthorizer(
      authStore.user,
      authStore.brandSession,
      'sessionRestore'
    )

    const { useIntercomStore } = await import('@/core/public/useIntercomStore')
    void useIntercomStore().initializeIntercom()

    const { cobrowse } = await import('@/plugins/cobrowse')
    void cobrowse.init({
      app: 'hermes',
      brand: '',
      brandId: authStore.brandSession?.brandId ?? '',
      email: authStore.user.email ?? '',
      userName: `${authStore.user.firstName} ${authStore.user.lastName}`,
    })
  }

  if (meta.isPublic) {
    if (meta.preventAuthenticatedRedirect) return undefined

    if (authStore.isAuthenticated) return authStore.home
  } else {
    if (!authStore.isAuthenticated) return getRedirectToLogin(to)
  }
}
